import { environmentConfiguration } from 'config/environment'

const tpmHost = environmentConfiguration.tpmHost;

export function postUpvote(widgetId) {
  const request = new XMLHttpRequest();
  // If you care about what happens with this request:

  // request.onreadystatechange=function() {
  //   if (request.readyState == 4 && request.status == 201) {
  //     var serverResponse = request.responseText;
  //     console.log(serverResponse);
  //   }
  // }

  // But yeah, we don't care what happens with this request right now.

  request.open("POST", `${tpmHost}/widgets/${widgetId}/upvote`, true);
  request.send();
}

export function getPlaceInfo(widgetId, callback) {
  const request = new XMLHttpRequest();
  request.onreadystatechange = function() {
    if (request.readyState == 4 && request.status == 200) {
      var responseJson = JSON.parse(request.responseText);
      callback(responseJson)
    }
  }

  request.open("GET", `${tpmHost}/widgets/${widgetId}.json`, true);
  request.send();
}



/** WEBPACK FOOTER **
 ** ./lib/ajax.js
 **/